import { useEffect } from "react";

export const useTitle = (title: string) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Chart Audit`;
    } else {
      document.title = "Chart Audit";
    }
  }, [title]);
};
